import React from 'react';
import './Process.css';

const Process = () => {
  const steps = [
    {
      num: '01',
      title: 'Discovery call',
      desc: 'A 30-minute conversation to understand where you are, what you\'re navigating, and whether working together makes sense.'
    },
    {
      num: '02',
      title: 'Diagnostic',
      desc: 'Before any work begins, we spend time understanding your current communications landscape — what\'s working, what isn\'t, and where the highest-leverage opportunities are.'
    },
    {
      num: '03',
      title: 'Focused engagement',
      desc: 'Every engagement is scoped precisely — no bloated retainers, no work that doesn\'t move the needle. We define outcomes at the start and measure against them throughout.'
    },
    {
      num: '04',
      title: 'Ongoing advisory',
      desc: 'For leaders who want a trusted thought partner on communications decisions as they arise — not just during a defined engagement. Available as a retained relationship.'
    }
  ];

  return (
    <section className="process" id="process">
      <div className="process-inner">
        <p className="section-label">How it works</p>
        <h2 className="section-heading">Precise by design.</h2>
        <div className="process-steps">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="process-step-num">{step.num}</div>
              <div>
                <h3 className="process-step-title">{step.title}</h3>
                <p className="process-step-desc">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
